import { render, staticRenderFns } from "./blockData.vue?vue&type=template&id=d1e56822&scoped=true&"
import script from "./blockData.vue?vue&type=script&lang=js&"
export * from "./blockData.vue?vue&type=script&lang=js&"
import style0 from "./blockData.vue?vue&type=style&index=0&id=d1e56822&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1e56822",
  null
  
)

export default component.exports